import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProjectProvider } from "@/context/ProjectContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Dashboard from "@/pages/Dashboard";
import Progress from "@/pages/Progress";
import FileRequests from "@/pages/FileRequests";
import Rfis from "@/pages/Rfis";
import Payments from "@/pages/Payments";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";
import Drive from "@/pages/Drive";
import ProjectFileSharing from "@/pages/ProjectFileSharing";
import Members from "@/pages/Members";
import Guide from "@/pages/Guide";
import Support from "@/pages/Support";
import Chat from "@/pages/Chat";
import ProgressChart from "@/pages/ProgressChart";
import ShareLanding from "@/pages/ShareLanding";
import StudioManpower from "@/pages/StudioManpower";
import StudioOrgChart from "@/pages/StudioOrgChart";
import StudioGantt from "@/pages/StudioGantt";
import StudioDiagrams from "@/pages/StudioDiagrams";
import StudioWorkProgram from "@/pages/StudioWorkProgram";
import CompanyChat from "@/pages/CompanyChat";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background" data-testid="auth-loading">
        <Loader2 className="h-8 w-8 animate-spin text-sky-600" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ProjectProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/invite/:token" element={<AcceptInvite />} />
            <Route path="/share/:token" element={<ShareLanding />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/progress" element={<Progress />} />
              <Route path="/files" element={<FileRequests />} />
              <Route path="/drive" element={<Drive />} />
              <Route path="/studio/manpower" element={<StudioManpower />} />
              <Route path="/studio/org-chart" element={<StudioOrgChart />} />
              <Route path="/studio/gantt" element={<StudioGantt />} />
              <Route path="/studio/diagrams" element={<StudioDiagrams />} />
              <Route path="/studio/work-program" element={<StudioWorkProgram />} />
              <Route path="/company-chat" element={<CompanyChat />} />
              <Route path="/sharing" element={<ProjectFileSharing />} />
              <Route path="/members" element={<Members />} />
              <Route path="/support" element={<Support />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/guide" element={<Guide />} />
              <Route path="/progress-chart" element={<ProgressChart />} />
              <Route path="/rfis" element={<Rfis />} />
              <Route path="/payments" element={<Payments />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/profile" element={<Profile />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </ProjectProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
